/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetStatusOk
 */
export interface GetStatusOk {
    /**
     * Current online player count
     * @type {number}
     * @memberof GetStatusOk
     */
    players: number;
    /**
     * Running version as string
     * @type {string}
     * @memberof GetStatusOk
     */
    serverVersion: string;
    /**
     * Server start timestamp
     * @type {Date}
     * @memberof GetStatusOk
     */
    startTime: Date;
    /**
     * If the server is in VIP mode
     * @type {boolean}
     * @memberof GetStatusOk
     */
    vip?: boolean;
}

/**
 * Check if a given object implements the GetStatusOk interface.
 */
export function instanceOfGetStatusOk(value: object): value is GetStatusOk {
    if (!('players' in value) || value['players'] === undefined) return false;
    if (!('serverVersion' in value) || value['serverVersion'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    return true;
}

export function GetStatusOkFromJSON(json: any): GetStatusOk {
    return GetStatusOkFromJSONTyped(json, false);
}

export function GetStatusOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatusOk {
    if (json == null) {
        return json;
    }
    return {
        
        'players': json['players'],
        'serverVersion': json['server_version'],
        'startTime': (new Date(json['start_time'])),
        'vip': json['vip'] == null ? undefined : json['vip'],
    };
}

export function GetStatusOkToJSON(json: any): GetStatusOk {
    return GetStatusOkToJSONTyped(json, false);
}

export function GetStatusOkToJSONTyped(value?: GetStatusOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'players': value['players'],
        'server_version': value['serverVersion'],
        'start_time': ((value['startTime']).toISOString()),
        'vip': value['vip'],
    };
}

